import React from 'react'

import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import ExternalLink from '@components/shared/ExternalLink'
import { PRESS_LINK } from '@utils/global'
import PageRoutes from '@utils/page-routes'

const CompanySection: React.FC = () => {
  const { t } = useTranslation()
  return (
    <ul className="p-2.5 sm:mr-9 lg:mr-0 basis-1/2 sm:basis-[auto]">
      <li className="font-medium text-md mb-0.5">{t('footer.company.title')}</li>
      <li className="py-0.5">
        <Link to={PageRoutes.aboutPath()} className="link" reloadDocument>
          {t('footer.company.about')}
        </Link>
      </li>
      <li className="py-0.5">
        <Link to={PageRoutes.teamPath()} className="link" reloadDocument>
          {t('footer.company.team')}
        </Link>
      </li>
      <li className="py-0.5">
        <Link to={PageRoutes.jobPath()} className="link" reloadDocument>
          {t('footer.company.jobs')}
        </Link>
      </li>
      <li className="py-0.5">
        <ExternalLink href={PRESS_LINK} className="link">
          {t('footer.company.press')}
        </ExternalLink>
      </li>
      <li className="py-0.5">
        <Link to={PageRoutes.siteHomePath()} className="link" reloadDocument>
          {t('footer.company.home')}
        </Link>
      </li>
    </ul>
  )
}

export default CompanySection
